// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  DownloadStatus,
} from "./types";


export default __t.row({
  progressId: __t.u64().primaryKey().name("progress_id"),
  userIdentity: __t.identity().name("user_identity"),
  versionId: __t.u64().name("version_id"),
  get status() {
    return DownloadStatus;
  },
  bytesDownloaded: __t.u64().name("bytes_downloaded"),
  totalBytes: __t.u64().name("total_bytes"),
  startedAt: __t.timestamp().name("started_at"),
  updatedAt: __t.timestamp().name("updated_at"),
  completedAt: __t.option(__t.timestamp()).name("completed_at"),
  errorMessage: __t.option(__t.string()).name("error_message"),
  statusMessage: __t.option(__t.string()).name("status_message"),
  appId: __t.option(__t.string()).name("app_id"),
});
